export default __webpack_public_path__ + "static/media/avatar_xiao_mei6.e1c74562.mp3";